import React from 'react'
import cls from 'classnames'
import { BatchStop, BatchNum, BatchOptions, } from 'component'
import { BatchAllButton } from 'component/batch'
import css from './index.module.less'

type BatchRowProps={
  data:any[],
  visible:boolean
  onCancel?:()=>void
  // onSelectAll?:()=>void
  // onUnselectAll?:()=>void
  onMove?:()=>void
  onExport?:()=>void
  style?:React.CSSProperties
}
export function BatchTools({ visible, data, onExport, style, onCancel, onMove }:BatchRowProps) {
  return <div className={cls(css.row, { [css.active]: visible })} style={style}>
    <span>批量操作</span>
    <div>
      <BatchNum style={{ marginRight: 40 }} />
      <BatchAllButton
        style={{ marginRight: 16 }}
        keyValues={data?.map(m => m.id)}
        infos={data}
      />
      <BatchStop onClick={onCancel} />
      <span className={css.line} />
      <BatchOptions.MoveSample green onChange={onMove} />
      <BatchOptions.ExportSample green fileName="样衣管理_样衣列表" onChange={onExport} />
    </div>
  </div>
}
